export default "__VITE_ASSET__DoTrrKbJ__"